import { createSitemap } from '@mui/internal-docs-infra/createSitemap';
const Overview = null;
const Endpoints = null;
const OverviewRu = null;
const EndpointsRu = null;

export const sitemap = createSitemap(import.meta.url, { Overview, Endpoints, OverviewRu, EndpointsRu }, { precompute: {
  "schema": {
    "slug": "string",
    "path": "string",
    "title": "string",
    "description": "string",
    "sections": "string[]",
    "subsections": "string[]",
    "keywords": "string[]"
  },
  "data": {
    "Overview": {
      "title": "Overview",
      "pages": [
        {
          "slug": "quick-start",
          "path": "./quick-start/page.mdx",
          "title": "Quick start",
          "description": "A quick guide to getting started with Statsnet API.",
          "keywords": [
            "Statsnet API",
            "Quick Start",
            "API key",
            "Company verification",
            "Compliance",
            "KYB",
            "Risk monitoring",
            "Onboarding",
            "Business data"
          ],
          "sections": {
            "step-1-get-your-api-key": {
              "title": "Step 1. Get your API key"
            },
            "step-2-make-an-api-request": {
              "title": "Step 2. Make an API request"
            },
            "step-3-connect-your-ai-agent-optional": {
              "title": "Step 3. Connect your AI agent (optional)"
            },
            "questions": {
              "title": "Questions?"
            }
          }
        },
        {
          "slug": "status-codes",
          "path": "./status-codes/page.mdx",
          "title": "Status codes",
          "description": "HTTP status codes returned by the Statsnet API.",
          "keywords": [
            "Statsnet API",
            "Status Codes",
            "HTTP Errors",
            "Error Handling",
            "API Errors",
            "Rate Limiting"
          ],
          "sections": {
            "success-codes": {
              "title": "Success Codes"
            },
            "client-error-codes": {
              "title": "Client Error Codes"
            },
            "server-error-codes": {
              "title": "Server Error Codes"
            },
            "error-response-format": {
              "title": "Error Response Format"
            }
          }
        },
        {
          "slug": "authentication",
          "path": "./authentication/page.mdx",
          "title": "Authentication",
          "description": "How to authenticate your API requests with Statsnet.",
          "keywords": [
            "Statsnet API",
            "Authentication",
            "API Key",
            "Authorization",
            "Python",
            "TypeScript",
            "Go",
            "Rust",
            "C#",
            "C++"
          ],
          "sections": {
            "getting-a-key": {
              "title": "Getting a key"
            },
            "what-a-key-can-access": {
              "title": "What a key can access"
            },
            "code-examples": {
              "title": "Code Examples"
            },
            "error-handling": {
              "title": "Error Handling"
            }
          }
        },
        {
          "slug": "mcp-server",
          "path": "./mcp/page.mdx",
          "title": "MCP Server",
          "description": "Connect AI agents to Statsnet over the Model Context Protocol.",
          "keywords": [
            "Statsnet MCP",
            "Model Context Protocol",
            "AI agents",
            "Claude",
            "Cursor",
            "Company data",
            "KYB"
          ],
          "sections": {
            "tools": {
              "title": "Tools"
            },
            "connect": {
              "title": "Connect"
            },
            "errors": {
              "title": "Errors"
            }
          }
        },
        {
          "slug": "about-statsnet-api",
          "path": "./about/page.mdx",
          "title": "About Statsnet API",
          "description": "A unified, reliable source of business data on 450M+ companies in 260 countries.",
          "keywords": [
            "Statsnet",
            "About",
            "Business Data",
            "API",
            "SDK",
            "FAQ",
            "Pricing",
            "Requests"
          ],
          "sections": {
            "faq": {
              "title": "FAQ",
              "children": {
                "can-i-buy-a-subscription-for-half-a-year-a-month-or-a-day": {
                  "title": "Can I buy a subscription for half a year, a month, or a day?"
                },
                "what-are-requests": {
                  "title": "What are requests?"
                },
                "what-happens-if-i-exceed-the-request-limit": {
                  "title": "What happens if I exceed the request limit?"
                },
                "how-do-i-get-access": {
                  "title": "How do I get access?"
                }
              }
            }
          }
        }
      ],
      "pageMetadata": {
        "robots": {
          "index": false
        },
        "other": {
          "audience": "private"
        }
      },
      "prefix": "/overview/"
    },
    "Endpoints": {
      "title": "Endpoints",
      "pages": [
        {
          "slug": "get-company",
          "path": "./company/page.mdx",
          "title": "Get Company",
          "description": "Retrieve detailed information about a company by its ID.",
          "keywords": [
            "Statsnet API",
            "Company",
            "Get Company",
            "Company Details"
          ],
          "sections": {
            "endpoint": {
              "title": "Endpoint"
            },
            "parameters": {
              "title": "Parameters"
            },
            "code-examples": {
              "title": "Code Examples"
            },
            "response": {
              "title": "Response"
            },
            "error-handling": {
              "title": "Error Handling"
            }
          }
        },
        {
          "slug": "get-company-paid",
          "path": "./company-paid/page.mdx",
          "title": "Get Company (Paid)",
          "description": "Retrieve full company data with premium access.",
          "keywords": [
            "Statsnet API",
            "Company",
            "Paid",
            "Premium",
            "Full Data"
          ],
          "sections": {
            "endpoint": {
              "title": "Endpoint"
            },
            "parameters": {
              "title": "Parameters"
            },
            "code-examples": {
              "title": "Code Examples"
            },
            "response": {
              "title": "Response"
            },
            "error-handling": {
              "title": "Error Handling"
            }
          }
        },
        {
          "slug": "available-data",
          "path": "./company-data/page.mdx",
          "title": "Available Data",
          "description": "List available data categories for a company.",
          "keywords": [
            "Statsnet API",
            "Available Data",
            "Company Data",
            "Data Categories"
          ],
          "sections": {
            "endpoint": {
              "title": "Endpoint"
            },
            "parameters": {
              "title": "Parameters"
            },
            "code-examples": {
              "title": "Code Examples"
            },
            "response": {
              "title": "Response"
            },
            "error-handling": {
              "title": "Error Handling"
            }
          }
        },
        {
          "slug": "debtors",
          "path": "./debtors/page.mdx",
          "title": "Debtors",
          "description": "Get debtor records for a company.",
          "keywords": [
            "Statsnet API",
            "Debtors",
            "Enforcement Proceedings",
            "Debt Records"
          ],
          "sections": {
            "endpoint": {
              "title": "Endpoint"
            },
            "parameters": {
              "title": "Parameters"
            },
            "code-examples": {
              "title": "Code Examples"
            },
            "response": {
              "title": "Response"
            },
            "error-handling": {
              "title": "Error Handling"
            }
          }
        },
        {
          "slug": "employees",
          "path": "./employees/page.mdx",
          "title": "Employees",
          "description": "Get employee records for a company.",
          "keywords": [
            "Statsnet API",
            "Employees",
            "Company Employees",
            "Staff"
          ],
          "sections": {
            "endpoint": {
              "title": "Endpoint"
            },
            "parameters": {
              "title": "Parameters"
            },
            "code-examples": {
              "title": "Code Examples"
            },
            "response": {
              "title": "Response"
            },
            "error-handling": {
              "title": "Error Handling"
            }
          }
        },
        {
          "slug": "events",
          "path": "./events/page.mdx",
          "title": "Events",
          "description": "Get event history for a company.",
          "keywords": [
            "Statsnet API",
            "Events",
            "Company Events",
            "Change History"
          ],
          "sections": {
            "endpoint": {
              "title": "Endpoint"
            },
            "parameters": {
              "title": "Parameters"
            },
            "code-examples": {
              "title": "Code Examples"
            },
            "response": {
              "title": "Response"
            },
            "error-handling": {
              "title": "Error Handling"
            }
          }
        },
        {
          "slug": "bank-accounts",
          "path": "./bank-accounts/page.mdx",
          "title": "Bank Accounts",
          "description": "Get bank account records for a company.",
          "keywords": [
            "Statsnet API",
            "Bank Accounts",
            "IBAN",
            "Company Banking"
          ],
          "sections": {
            "endpoint": {
              "title": "Endpoint"
            },
            "parameters": {
              "title": "Parameters"
            },
            "code-examples": {
              "title": "Code Examples"
            },
            "response": {
              "title": "Response"
            },
            "error-handling": {
              "title": "Error Handling"
            }
          }
        },
        {
          "slug": "stores",
          "path": "./stores/page.mdx",
          "title": "Stores",
          "description": "Get store locations for a company.",
          "keywords": [
            "Statsnet API",
            "Stores",
            "Branches",
            "Company Locations"
          ],
          "sections": {
            "endpoint": {
              "title": "Endpoint"
            },
            "parameters": {
              "title": "Parameters"
            },
            "code-examples": {
              "title": "Code Examples"
            },
            "response": {
              "title": "Response"
            },
            "error-handling": {
              "title": "Error Handling"
            }
          }
        },
        {
          "slug": "certificates",
          "path": "./certs/page.mdx",
          "title": "Certificates",
          "description": "Get certificate records for a company.",
          "keywords": [
            "Statsnet API",
            "Certificates",
            "Conformity",
            "Certification"
          ],
          "sections": {
            "endpoint": {
              "title": "Endpoint"
            },
            "parameters": {
              "title": "Parameters"
            },
            "code-examples": {
              "title": "Code Examples"
            },
            "response": {
              "title": "Response"
            },
            "error-handling": {
              "title": "Error Handling"
            }
          }
        },
        {
          "slug": "licenses",
          "path": "./licenses/page.mdx",
          "title": "Licenses",
          "description": "Get license records for a company.",
          "keywords": [
            "Statsnet API",
            "Licenses",
            "Company Licenses",
            "Permits"
          ],
          "sections": {
            "endpoint": {
              "title": "Endpoint"
            },
            "parameters": {
              "title": "Parameters"
            },
            "code-examples": {
              "title": "Code Examples"
            },
            "response": {
              "title": "Response"
            },
            "error-handling": {
              "title": "Error Handling"
            }
          }
        },
        {
          "slug": "jobs",
          "path": "./jobs/page.mdx",
          "title": "Jobs",
          "description": "Get job postings for a company.",
          "keywords": [
            "Statsnet API",
            "Jobs",
            "Job Postings",
            "Vacancies"
          ],
          "sections": {
            "endpoint": {
              "title": "Endpoint"
            },
            "parameters": {
              "title": "Parameters"
            },
            "code-examples": {
              "title": "Code Examples"
            },
            "response": {
              "title": "Response"
            },
            "error-handling": {
              "title": "Error Handling"
            }
          }
        },
        {
          "slug": "domains",
          "path": "./domains/page.mdx",
          "title": "Domains",
          "description": "Get domain records for a company.",
          "keywords": [
            "Statsnet API",
            "Domains",
            "Websites",
            "Company Domains"
          ],
          "sections": {
            "endpoint": {
              "title": "Endpoint"
            },
            "parameters": {
              "title": "Parameters"
            },
            "code-examples": {
              "title": "Code Examples"
            },
            "response": {
              "title": "Response"
            },
            "error-handling": {
              "title": "Error Handling"
            }
          }
        },
        {
          "slug": "social-networks",
          "path": "./social-networks/page.mdx",
          "title": "Social Networks",
          "description": "Get social network profiles for a company.",
          "keywords": [
            "Statsnet API",
            "Social Networks",
            "Company Profiles",
            "Social Media"
          ],
          "sections": {
            "endpoint": {
              "title": "Endpoint"
            },
            "parameters": {
              "title": "Parameters"
            },
            "code-examples": {
              "title": "Code Examples"
            },
            "response": {
              "title": "Response"
            },
            "error-handling": {
              "title": "Error Handling"
            }
          }
        },
        {
          "slug": "reviews",
          "path": "./review/page.mdx",
          "title": "Reviews",
          "description": "Get review and website records for a company.",
          "keywords": [
            "Statsnet API",
            "Reviews",
            "Websites",
            "Company Reviews"
          ],
          "sections": {
            "endpoint": {
              "title": "Endpoint"
            },
            "parameters": {
              "title": "Parameters"
            },
            "code-examples": {
              "title": "Code Examples"
            },
            "response": {
              "title": "Response"
            },
            "error-handling": {
              "title": "Error Handling"
            }
          }
        },
        {
          "slug": "departments",
          "path": "./department/page.mdx",
          "title": "Departments",
          "description": "Get department information for a company.",
          "keywords": [
            "Statsnet API",
            "Departments",
            "Company Divisions",
            "Organization Structure"
          ],
          "sections": {
            "endpoint": {
              "title": "Endpoint"
            },
            "parameters": {
              "title": "Parameters"
            },
            "code-examples": {
              "title": "Code Examples"
            },
            "response": {
              "title": "Response"
            },
            "error-handling": {
              "title": "Error Handling"
            }
          }
        },
        {
          "slug": "subsidiaries",
          "path": "./subsidiaries/page.mdx",
          "title": "Subsidiaries",
          "description": "Get subsidiary companies.",
          "keywords": [
            "Statsnet API",
            "Subsidiaries",
            "Child Companies",
            "Corporate Structure"
          ],
          "sections": {
            "endpoint": {
              "title": "Endpoint"
            },
            "parameters": {
              "title": "Parameters"
            },
            "code-examples": {
              "title": "Code Examples"
            },
            "response": {
              "title": "Response"
            },
            "error-handling": {
              "title": "Error Handling"
            }
          }
        },
        {
          "slug": "government-contracts",
          "path": "./gov-contracts/page.mdx",
          "title": "Government Contracts",
          "description": "Get government contract records for a company.",
          "keywords": [
            "Statsnet API",
            "Government Contracts",
            "Public Procurement",
            "Tenders"
          ],
          "sections": {
            "endpoint": {
              "title": "Endpoint"
            },
            "parameters": {
              "title": "Parameters"
            },
            "code-examples": {
              "title": "Code Examples"
            },
            "response": {
              "title": "Response"
            },
            "error-handling": {
              "title": "Error Handling"
            }
          }
        },
        {
          "slug": "government-applications",
          "path": "./gov-applications/page.mdx",
          "title": "Government Applications",
          "description": "Get government application records for a company.",
          "keywords": [
            "Statsnet API",
            "Government Applications",
            "Public Applications"
          ],
          "sections": {
            "endpoint": {
              "title": "Endpoint"
            },
            "parameters": {
              "title": "Parameters"
            },
            "code-examples": {
              "title": "Code Examples"
            },
            "response": {
              "title": "Response"
            },
            "error-handling": {
              "title": "Error Handling"
            }
          }
        },
        {
          "slug": "tax-declarations",
          "path": "./tax-declarations/page.mdx",
          "title": "Tax Declarations",
          "description": "Get tax declaration records for a company.",
          "keywords": [
            "Statsnet API",
            "Tax Declarations",
            "Tax Records",
            "Accruals"
          ],
          "sections": {
            "endpoint": {
              "title": "Endpoint"
            },
            "parameters": {
              "title": "Parameters"
            },
            "code-examples": {
              "title": "Code Examples"
            },
            "response": {
              "title": "Response"
            },
            "error-handling": {
              "title": "Error Handling"
            }
          }
        },
        {
          "slug": "relations-graph",
          "path": "./relations/page.mdx",
          "title": "Relations (Graph)",
          "description": "Get company relations and affiliations as a graph.",
          "keywords": [
            "Statsnet API",
            "Relations",
            "Affiliations",
            "Corporate Graph",
            "Connections"
          ],
          "sections": {
            "endpoint": {
              "title": "Endpoint"
            },
            "parameters": {
              "title": "Parameters"
            },
            "code-examples": {
              "title": "Code Examples"
            },
            "response": {
              "title": "Response"
            },
            "error-handling": {
              "title": "Error Handling"
            }
          }
        },
        {
          "slug": "relations-table",
          "path": "./relations-table/page.mdx",
          "title": "Relations (Table)",
          "description": "Get company relations and affiliations as a list.",
          "keywords": [
            "Statsnet API",
            "Relations Table",
            "Affiliations List",
            "Corporate Connections"
          ],
          "sections": {
            "endpoint": {
              "title": "Endpoint"
            },
            "parameters": {
              "title": "Parameters"
            },
            "code-examples": {
              "title": "Code Examples"
            },
            "response": {
              "title": "Response"
            },
            "error-handling": {
              "title": "Error Handling"
            }
          }
        },
        {
          "slug": "contracts-metadata",
          "path": "./contracts-meta/page.mdx",
          "title": "Contracts Metadata",
          "description": "Get contract metadata for a company.",
          "keywords": [
            "Statsnet API",
            "Contracts",
            "Contract Metadata",
            "Procurement"
          ],
          "sections": {
            "endpoint": {
              "title": "Endpoint"
            },
            "parameters": {
              "title": "Parameters"
            },
            "code-examples": {
              "title": "Code Examples"
            },
            "response": {
              "title": "Response"
            },
            "error-handling": {
              "title": "Error Handling"
            }
          }
        },
        {
          "slug": "quasi-contracts",
          "path": "./quasi-contracts/page.mdx",
          "title": "Quasi-Contracts",
          "description": "Get quasi-contract records for a company.",
          "keywords": [
            "Statsnet API",
            "Quasi-Contracts",
            "Procurement"
          ],
          "sections": {
            "endpoint": {
              "title": "Endpoint"
            },
            "parameters": {
              "title": "Parameters"
            },
            "code-examples": {
              "title": "Code Examples"
            },
            "response": {
              "title": "Response"
            },
            "error-handling": {
              "title": "Error Handling"
            }
          }
        },
        {
          "slug": "quasi-contracts-metadata",
          "path": "./quasi-contracts-meta/page.mdx",
          "title": "Quasi-Contracts Metadata",
          "description": "Get quasi-contract metadata for a company.",
          "keywords": [
            "Statsnet API",
            "Quasi-Contracts",
            "Metadata",
            "Procurement Summary"
          ],
          "sections": {
            "endpoint": {
              "title": "Endpoint"
            },
            "parameters": {
              "title": "Parameters"
            },
            "code-examples": {
              "title": "Code Examples"
            },
            "response": {
              "title": "Response"
            },
            "error-handling": {
              "title": "Error Handling"
            }
          }
        },
        {
          "slug": "pos-terminals",
          "path": "./pos-terminals/page.mdx",
          "title": "POS Terminals",
          "description": "Get POS terminal records for a company.",
          "keywords": [
            "Statsnet API",
            "POS Terminals",
            "Point of Sale",
            "Payment Terminals"
          ],
          "sections": {
            "endpoint": {
              "title": "Endpoint"
            },
            "parameters": {
              "title": "Parameters"
            },
            "code-examples": {
              "title": "Code Examples"
            },
            "response": {
              "title": "Response"
            },
            "error-handling": {
              "title": "Error Handling"
            }
          }
        },
        {
          "slug": "rights",
          "path": "./rights/page.mdx",
          "title": "Rights",
          "description": "Get intellectual property rights for a company.",
          "keywords": [
            "Statsnet API",
            "Rights",
            "Intellectual Property",
            "Trademarks",
            "Patents"
          ],
          "sections": {
            "endpoint": {
              "title": "Endpoint"
            },
            "parameters": {
              "title": "Parameters"
            },
            "code-examples": {
              "title": "Code Examples"
            },
            "response": {
              "title": "Response"
            },
            "error-handling": {
              "title": "Error Handling"
            }
          }
        },
        {
          "slug": "view-metadata",
          "path": "./view-meta/page.mdx",
          "title": "View Metadata",
          "description": "Get display metadata for a company.",
          "keywords": [
            "Statsnet API",
            "View Metadata",
            "Display Meta",
            "Data Counts"
          ],
          "sections": {
            "endpoint": {
              "title": "Endpoint"
            },
            "parameters": {
              "title": "Parameters"
            },
            "code-examples": {
              "title": "Code Examples"
            },
            "response": {
              "title": "Response"
            },
            "error-handling": {
              "title": "Error Handling"
            }
          }
        },
        {
          "slug": "view",
          "path": "./view/page.mdx",
          "title": "View",
          "description": "Get new metadata view for a company.",
          "keywords": [
            "Statsnet API",
            "Company View",
            "Metadata View"
          ],
          "sections": {
            "endpoint": {
              "title": "Endpoint"
            },
            "parameters": {
              "title": "Parameters"
            },
            "code-examples": {
              "title": "Code Examples"
            },
            "response": {
              "title": "Response"
            },
            "error-handling": {
              "title": "Error Handling"
            }
          }
        },
        {
          "slug": "metadata-beta",
          "path": "./meta-beta/page.mdx",
          "title": "Metadata (Beta)",
          "description": "Get beta metadata for a company.",
          "keywords": [
            "Statsnet API",
            "Beta Metadata",
            "Experimental",
            "Company Meta"
          ],
          "sections": {
            "endpoint": {
              "title": "Endpoint"
            },
            "parameters": {
              "title": "Parameters"
            },
            "code-examples": {
              "title": "Code Examples"
            },
            "response": {
              "title": "Response"
            },
            "error-handling": {
              "title": "Error Handling"
            }
          }
        }
      ],
      "pageMetadata": {
        "robots": {
          "index": false
        },
        "other": {
          "audience": "private"
        }
      },
      "prefix": "/endpoints/"
    },
    "OverviewRu": {
      "title": "Ru Overview",
      "pages": [
        {
          "slug": "quick-start",
          "path": "./quick-start/page.mdx",
          "title": "Quick start",
          "description": "Краткое руководство по началу работы со Statsnet API.",
          "keywords": [
            "Statsnet API",
            "Quick Start",
            "API key",
            "Проверка компаний",
            "Комплаенс",
            "KYB",
            "Мониторинг рисков",
            "Онбординг",
            "Данные о бизнесе"
          ],
          "sections": {
            "1-api": {
              "title": "Шаг 1. Получите API-ключ"
            },
            "2-api": {
              "title": "Шаг 2. Сделайте запрос к API"
            },
            "3-ai": {
              "title": "Шаг 3. Подключите AI-агента (опционально)"
            }
          }
        },
        {
          "slug": "",
          "path": "./status-codes/page.mdx",
          "title": "Аутентификация",
          "description": "No description available"
        },
        {
          "slug": "",
          "path": "./authentication/page.mdx",
          "title": "Аутентификация",
          "description": "No description available"
        },
        {
          "slug": "mcp",
          "path": "./mcp/page.mdx",
          "title": "MCP-сервер",
          "description": "Подключите AI-агентов к Statsnet по Model Context Protocol.",
          "keywords": [
            "Statsnet MCP",
            "Model Context Protocol",
            "AI-агенты",
            "Claude",
            "Cursor",
            "Данные о компаниях",
            "KYB"
          ]
        },
        {
          "slug": "statsnet-api",
          "path": "./about/page.mdx",
          "title": "О Statsnet API",
          "description": "Единый, надёжный источник бизнес-данных о 450M+ компаниях в 260 странах.",
          "keywords": [
            "Statsnet",
            "О компании",
            "Бизнес-данные",
            "API",
            "SDK",
            "FAQ",
            "Тарифы",
            "Запросы"
          ],
          "sections": {}
        }
      ],
      "pageMetadata": {
        "robots": {
          "index": false
        },
        "other": {
          "audience": "private"
        }
      },
      "prefix": "/ru/overview/"
    },
    "EndpointsRu": {
      "title": "Ru Endpoints",
      "pages": [
        {
          "slug": "",
          "path": "./company/page.mdx",
          "title": "Метаданные (бета)",
          "description": "No description available"
        },
        {
          "slug": "",
          "path": "./company-paid/page.mdx",
          "title": "Метаданные (бета)",
          "description": "No description available"
        },
        {
          "slug": "",
          "path": "./company-data/page.mdx",
          "title": "Метаданные (бета)",
          "description": "No description available"
        },
        {
          "slug": "",
          "path": "./debtors/page.mdx",
          "title": "Метаданные (бета)",
          "description": "No description available"
        },
        {
          "slug": "",
          "path": "./employees/page.mdx",
          "title": "Метаданные (бета)",
          "description": "No description available"
        },
        {
          "slug": "",
          "path": "./events/page.mdx",
          "title": "Метаданные (бета)",
          "description": "No description available"
        },
        {
          "slug": "",
          "path": "./bank-accounts/page.mdx",
          "title": "Метаданные (бета)",
          "description": "No description available"
        },
        {
          "slug": "",
          "path": "./stores/page.mdx",
          "title": "Метаданные (бета)",
          "description": "No description available"
        },
        {
          "slug": "",
          "path": "./certs/page.mdx",
          "title": "Метаданные (бета)",
          "description": "No description available"
        },
        {
          "slug": "",
          "path": "./licenses/page.mdx",
          "title": "Метаданные (бета)",
          "description": "No description available"
        },
        {
          "slug": "",
          "path": "./jobs/page.mdx",
          "title": "Метаданные (бета)",
          "description": "No description available"
        },
        {
          "slug": "",
          "path": "./domains/page.mdx",
          "title": "Метаданные (бета)",
          "description": "No description available"
        },
        {
          "slug": "",
          "path": "./social-networks/page.mdx",
          "title": "Метаданные (бета)",
          "description": "No description available"
        },
        {
          "slug": "",
          "path": "./review/page.mdx",
          "title": "Отзывы",
          "description": "No description available",
          "displayTitle": "Метаданные (бета)"
        },
        {
          "slug": "",
          "path": "./department/page.mdx",
          "title": "Метаданные (бета)",
          "description": "No description available"
        },
        {
          "slug": "",
          "path": "./subsidiaries/page.mdx",
          "title": "Метаданные (бета)",
          "description": "No description available"
        },
        {
          "slug": "",
          "path": "./gov-contracts/page.mdx",
          "title": "Метаданные (бета)",
          "description": "No description available"
        },
        {
          "slug": "",
          "path": "./gov-applications/page.mdx",
          "title": "Метаданные (бета)",
          "description": "No description available"
        },
        {
          "slug": "",
          "path": "./tax-declarations/page.mdx",
          "title": "Метаданные (бета)",
          "description": "No description available"
        },
        {
          "slug": "",
          "path": "./relations/page.mdx",
          "title": "Метаданные (бета)",
          "description": "No description available"
        },
        {
          "slug": "",
          "path": "./relations-table/page.mdx",
          "title": "Метаданные (бета)",
          "description": "No description available"
        },
        {
          "slug": "",
          "path": "./contracts-meta/page.mdx",
          "title": "Метаданные (бета)",
          "description": "No description available"
        },
        {
          "slug": "",
          "path": "./quasi-contracts/page.mdx",
          "title": "Метаданные (бета)",
          "description": "No description available"
        },
        {
          "slug": "",
          "path": "./quasi-contracts-meta/page.mdx",
          "title": "Метаданные (бета)",
          "description": "No description available"
        },
        {
          "slug": "pos",
          "path": "./pos-terminals/page.mdx",
          "title": "POS-терминалы",
          "description": "Получение POS-терминалов компании.",
          "keywords": [
            "Statsnet API",
            "POS-терминалы",
            "Платёжные терминалы"
          ]
        },
        {
          "slug": "",
          "path": "./rights/page.mdx",
          "title": "Метаданные (бета)",
          "description": "No description available"
        },
        {
          "slug": "",
          "path": "./view-meta/page.mdx",
          "title": "Метаданные (бета)",
          "description": "No description available"
        },
        {
          "slug": "",
          "path": "./view/page.mdx",
          "title": "Метаданные (бета)",
          "description": "No description available"
        },
        {
          "slug": "",
          "path": "./meta-beta/page.mdx",
          "title": "Метаданные (бета)",
          "description": "No description available"
        }
      ],
      "pageMetadata": {
        "robots": {
          "index": false
        },
        "other": {
          "audience": "private"
        }
      },
      "prefix": "/ru/endpoints/"
    }
  }
} });
